import { Translations } from './types/translations';

const translations: Translations = {
  en: {
    // Auth
    'welcome.back': 'Welcome Back!',
    'join.pool': 'Join Dynasty Hockey Pool',
    'need.account': 'Need an account? Register',
    'have.account': 'Already have an account? Log in',
    'email.address': 'Email address',
    password: 'Password',
    username: 'Username',
    'date.of.birth': 'Date of Birth',
    'create.account': 'Create Account',
    'creating.account': 'Creating account...',
    login: 'Log In',
    'logging.in': 'Logging in...',
  'remember.me': 'Remember me',
    'account.created': 'Account created successfully!',
    'registration.error': 'An error occurred during registration',
    'registration.email.exists': 'An account with this email already exists',

  // Password reset
  'forgot.password': 'Forgot password?',
  'new.password': 'New password',
  'reset.password': 'Reset password',
  'updating.password': 'Updating password...',
  'password.updated': 'Password updated',
  'password.update.failed': 'Failed to update password',
  'email.not.found': 'Email not found',

  // Birthdate Modal
  'complete.your.profile': 'Complete Your Profile',
  'birthdate.request.message': 'To improve your experience, please provide your date of birth.',
  'date.of.birth.required': 'Date of birth is required',
  'date.of.birth.updated': 'Date of birth updated successfully!',
  'error.updating.birthdate': 'An error occurred while updating your date of birth',
  'submitting': 'Submitting',
  'submit': 'Submit',
  'error.user.not.found': 'User not found',

    // Dashboard
    'hockey.dynasty.dashboard': 'Hockey Dynasty Dashboard',
    'welcome.user': 'Welcome back, {username}!',
    'create.new.league': 'Create New League',
    'select.my.league': 'Select My League',
    'join.league': 'Join League',

    // My Leagues
    'my.leagues': 'My Leagues',
    'no.leagues.yet': "You haven't joined any leagues yet.",
    'create.league.button': 'Create a New League',
    'join.existing.league': 'Join an Existing League',
    'welcome.to.dynasty': 'Welcome to Dynasty Hockey Pool',
    'start.journey':
      'Start your journey by creating a new league or joining an existing one',

    // General Manager Office
    'gm.office': 'General Manager Office',
    'my.team': 'My Team',
    'manage.team': 'Manage your team roster and lineup',
    'free.agents': 'Free Agents',
    'browse.agents': 'Browse and sign available players',
    standings: 'Standings',
    'view.standings': 'View league standings and statistics',
    waivers: 'Waivers',
    'players.waivers': 'Players available on waivers',
    'trade.center': 'Trade Center',
    'manage.trades': 'Propose and manage trades',
    messages: 'Messages',
    'league.communications': 'League communications and notifications',
    'league.rules': 'League Rules',
    'view.rules': 'View league settings and regulations',
    'league.settings': 'League Settings',
    'configure.settings': 'Configure league parameters',
    'coming.soon': 'Coming soon',
    'protection.list': 'Protection List',
    'manage.protection.list': 'Manage your protected players list',

  // Leave League
  'leave.league.description': 'When you leave the league, your team will be assigned temporarily to the guardian GM. Your players, draft picks, and standings points will be preserved until the next GM arrives, and your annual subscription will be cancelled automatically.',
  'leave.league.button': 'Leave the league (last resort)',
  'leave.league.tooltip': 'Leave the league and assign your roster to the guardian GM',
  'leave.league.note.default': 'Your recurring subscription will be cancelled automatically; contact the commissioner for any refund questions.',
  'leave.league.note.commissioner': 'Commissioners must transfer their rights before they can leave the league.',
  'leave.league.modal.title': 'Confirm league departure',
  'leave.league.modal.body': 'Are you sure you want to leave the league "{leagueName}"? Your team will be transferred to the guardian GM, your players will remain under contract, your standings points will be preserved, and your annual subscription will be cancelled automatically.',
  'leave.league.modal.irreversible': 'This action is irreversible.',
  'leave.league.modal.cancel': 'Cancel',
  'leave.league.modal.confirm': 'Confirm and leave the league',
  'leave.league.modal.progress': 'Transferring...',
  'leave.league.error.commissioner': 'A commissioner must transfer their rights before leaving the league.',
  'leave.league.error.invalidUser': 'Invalid user identifier.',
  'leave.league.error.generic': 'Unable to leave the league.',
  'leave.league.error.unexpected': 'An unexpected error occurred while leaving the league.',
  'leave.league.success': 'Your team has been assigned to the guardian GM.',
  'leave.league.cta.title': 'Leave the league and assign your roster to the guardian GM',

  // Guardian assignment
  'league.guardian.assignment.title': 'Assign guardian team',
  'league.guardian.assignment.description': 'Select a manager to inherit the guardian roster.',
  'league.guardian.assignment.currentTeam': 'Current guardian team',
  'league.guardian.assignment.teamFallback': 'Guardian GM',
  'league.guardian.assignment.select': 'Choose the new GM',
  'league.guardian.assignment.placeholder': '-- Select a manager without a team --',
  'league.guardian.assignment.helper': 'Only managers without an active roster can receive the guardian team.',
  'league.guardian.assignment.cta': 'Assign the guardian team',
  'league.guardian.assignment.loading': 'Assigning...',
  'league.guardian.assignment.noCandidates': 'No eligible managers without a team are available right now.',
  'league.guardian.assignment.noGuardian': 'No guardian team is available for this league.',
  'league.guardian.assignment.success': 'The guardian team has been transferred to the selected manager!',
  'league.guardian.assignment.error': 'Unable to assign the guardian team.',
  'league.guardian.assignment.error.generic': 'An error occurred while assigning the guardian team.',

  // Player Detail Page
  'player.detail.back': 'Back',
  'player.detail.open.nhl': 'Open NHL.com profile',
  'player.detail.invalid.id': 'Invalid player identifier',
  'player.detail.fetch.error': 'Unable to load player details',
  'player.detail.fetch.timeout': 'The NHL API took too long to respond',
  'player.detail.fetch.fallback': 'Unable to load this player right now. Please try again later.',
  'player.detail.team.unknown': 'Team unknown',
  'player.detail.position': 'Position',
  'player.detail.position.unknown': 'Unknown',
  'player.detail.biography': 'Biography',
  'player.detail.height': 'Height',
  'player.detail.height.cm': 'cm',
  'player.detail.weight': 'Weight',
  'player.detail.weight.kg': 'kg',
  'player.detail.weight.lbs': 'lbs',
  'player.detail.shoots': 'Shoots/Catches',
  'player.detail.shoots.left': 'Left',
  'player.detail.shoots.right': 'Right',
  'player.detail.shoots.catch': 'Catches',
  'player.detail.draft': 'Draft',
  'player.detail.birthplace': 'Birthplace',
  'player.detail.contract': 'Contract Information',
  'player.detail.salary': 'Salary',
  'player.detail.years.left': 'Years Remaining',
  'player.detail.years.left.value': '{years} year(s)',
  'player.detail.key.stats': 'Key statistics',
  'player.detail.regular.season': 'Regular season',
  'player.detail.regular.season.short': 'Season',
  'player.detail.playoffs': 'Playoffs',
  'player.detail.playoffs.short': 'Playoffs',
  'player.detail.stat.label': 'Stat',
  'player.detail.stat.season': 'Current season',
  'player.detail.stat.career': 'Career',
  'player.detail.last.games': 'Last 5 games',
  'player.detail.last.games.subtitle': 'Regular season & playoffs combined',
  'player.detail.opponent': 'Opponent',
  'player.detail.plusminus.short': '+/-',
  'player.detail.decision': 'Decision',
  'player.detail.decision.win': 'Win',
  'player.detail.decision.loss': 'Loss',
  'player.detail.decision.ot': 'Overtime loss',
  'player.detail.decision.so': 'Shootout loss',
  'player.detail.toi': 'TOI',
  'player.detail.no.games': 'No recent games available',
  'player.detail.current.roster': 'Current team roster',
  'player.detail.not.available': 'Not available',
  'player.detail.round': 'Round',
  'player.detail.pick.suffix': 'th overall',
  'player.detail.career.totals': 'Career totals',
  'player.detail.awards': 'Awards & trophies',
  'player.detail.awards.none': 'No awards recorded yet',
  'player.detail.season.stats': 'Season Statistics',
  'player.detail.select.season': 'Select Season',
  'player.detail.historical.stats': 'Historical Statistics',
  'player.detail.current.season': 'Current Season',
  'player.detail.loading.season': 'Loading season data...',
  'player.detail.no.season.data': 'No data available for this season',

  // Player Analytics Dashboard
  'player.detail.analytics.title': 'Analytics Dashboard',
  'player.detail.analytics.chart': 'Performance Chart',
  'player.detail.analytics.contract': 'Contract vs Production',
  'player.detail.analytics.transactions': 'Transaction History',
  'player.detail.analytics.no.league': 'Select a league to view transactions',
  'player.detail.analytics.no.transactions': 'No transactions found for this player',
  'player.detail.analytics.trade.sent': 'Traded to {username}',
  'player.detail.analytics.trade.received': 'Received from {username}',
  'player.detail.analytics.signing': 'Signed by {username}',
  'player.detail.analytics.chart.nhl.only': 'NHL regular season only',

  // NHL Edge Stats section
  'nhl.edge.title': 'NHL Edge™ Stats',
  'nhl.edge.subtitle': 'Advanced performance data powered by NHL Edge technology',
  'nhl.edge.game.type.regular': 'Regular season',
  'nhl.edge.game.type.playoffs': 'Playoffs',
  'nhl.edge.loading': 'Loading NHL Edge data…',
  'nhl.edge.error.unavailable': 'NHL Edge data unavailable for this player',
  'nhl.edge.error.no.data': 'No NHL Edge data found for this season',
  'nhl.edge.rank.of': 'of',
  'nhl.edge.rank.label': 'Rank',
  'nhl.edge.percentile': 'percentile',
  // Skater metrics
  'nhl.edge.skating.speed.title': 'Skating Speed',
  'nhl.edge.skating.speed.max': 'Top speed',
  'nhl.edge.skating.speed.bursts22': 'Bursts ≥ 22 mph',
  'nhl.edge.skating.speed.bursts20': 'Bursts 20–22 mph',
  'nhl.edge.skating.speed.unit': 'mph',
  'nhl.edge.shot.speed.title': 'Shot Speed',
  'nhl.edge.shot.speed.max': 'Top shot speed',
  'nhl.edge.shot.speed.unit': 'mph',
  'nhl.edge.distance.title': 'Skating Distance',
  'nhl.edge.distance.total': 'Total distance',
  'nhl.edge.distance.avg': 'Avg per game',
  'nhl.edge.distance.unit': 'km',
  'nhl.edge.zone.time.title': 'Zone Time',
  'nhl.edge.zone.time.offensive': 'Offensive zone',
  'nhl.edge.zone.time.neutral': 'Neutral zone',
  'nhl.edge.zone.time.defensive': 'Defensive zone',
  'nhl.edge.shot.location.title': 'Shots on Goal by Zone',
  'nhl.edge.shot.location.high.danger': 'High Danger',
  'nhl.edge.shot.location.mid.range': 'Mid-Range',
  'nhl.edge.shot.location.long.range': 'Long Range',
  'nhl.edge.shot.location.sog': 'SOG',
  'nhl.edge.shot.location.goals': 'Goals',
  'nhl.edge.shot.location.pctg': 'Sh%',
  // Goalie metrics
  'nhl.edge.goalie.gaa.title': 'Goals Against Average',
  'nhl.edge.goalie.games.above.900': 'Games Above .900',
  'nhl.edge.goalie.goal.differential': 'Goal Diff / 60 min',
  'nhl.edge.goalie.goal.support': 'Avg Goal Support',
  'nhl.edge.goalie.point.pctg': 'Point %',
  'nhl.edge.goalie.shot.location.title': 'Shot Location Breakdown',
  'nhl.edge.goalie.saves': 'Saves',
  'nhl.edge.goalie.goals.against': 'Goals Against',
  'nhl.edge.goalie.save.pctg': 'Save %',
  'nhl.edge.no.goalie.data': 'No NHL Edge data available for this goalie',

  'player.detail.contract.underpaid': '🟢 Underpaid',
  'player.detail.contract.fair': '🟡 Fair value',
  'player.detail.contract.overpaid': '🔴 Overpaid',
  'player.detail.contract.unknown': '⚪ No data',

  // Player Detail Stats labels
  'stat.gamesPlayed': 'Games played',
  'stat.goals': 'Goals',
  'stat.assists': 'Assists',
  'stat.points': 'Points',
  'stat.plusMinus': 'Plus/Minus',
  'stat.powerPlayGoals': 'Power-play goals',
  'stat.powerPlayPoints': 'Power-play points',
  'stat.shorthandedGoals': 'Shorthanded goals',
  'stat.shorthandedPoints': 'Shorthanded points',
  'stat.gameWinningGoals': 'Game-winning goals',
  'stat.shots': 'Shots',
  'stat.shootingPctg': 'Shooting %',
  'stat.pim': 'Penalty minutes',
  'stat.avgToi': 'Average TOI',
  'stat.faceoffWinningPctg': 'Faceoff %',
  'stat.wins': 'Wins',
  'stat.losses': 'Losses',
  'stat.otLosses': 'OT losses',
  'stat.goalsAgainst': 'Goals against',
  'stat.goalsAgainstAvg': 'Goals-against average',
  'stat.savePctg': 'Save percentage',
  'stat.savePctg.short': 'SV%',
  'stat.shutouts': 'Shutouts',
  'stat.shotsAgainst': 'Shots against',
  'stat.saves': 'Saves',
  date: 'Date',

    // Draft System
    'draft.title': 'League Draft',
    'draft.pick': 'Draft Pick',
    'draft.not.available': 'Draft System Coming Soon',
    'draft.messenger.info':
      'For now, please create a Messenger group with all league members to conduct the draft in turns efficiently.',
    'draft.create.group':
      'This ensures everyone can participate in real-time and makes the draft process smoother.',

    // Protection List Settings
    'protection.list.settings': 'End of Season Protection List',
    'number.forwards.protect': 'Number of Forwards to Protect',
    'number.defensemen.protect': 'Number of Defensemen to Protect',
    'number.goalies.protect': 'Number of Goalies to Protect',

    // My Team Page
    'my.team.title': 'My Team',
    'roster.limits': 'Roster Limits',
    forwards: 'Forwards',
    defensemen: 'Defensemen',
    goalies: 'Goalies',
    'reserve.players': 'Reserve Players',
    'salary.cap.usage': 'Salary Cap Usage',
    current: 'Current',
    maximum: 'Maximum',
    'main.club': 'Main Club',
    reserves: 'Reserves',
    scratch: 'Scratch Players',
    'scratch.player': 'Scratch Player',
    'filter.position': 'Filter by Position',
    'all.positions': 'All Positions',
    'forwards.crl': 'Forwards (C/L/R)',
    defense: 'Defense',
    center: 'Center',
    'left.wing': 'Left Wing',
    'right.wing': 'Right Wing',
    defenseman: 'Defenseman',
    'no.players.available':
      'No players available in {section} for the selected position.',
    'no.goalies.available': 'No goalies available in {section}.',
    previous: 'Previous',
    next: 'Next',
    page: 'Page',
    of: 'of',
    release: 'Release',
    promote: 'Promote',
    demote: 'Demote',
    name: 'Name',
    position: 'Position',
    team: 'Team',
    salary: 'Salary',
    'selection.percentage': '%sel.',
    'years.left': 'Years Left',
    gp: 'GP',
    goals: 'G',
    assists: 'A',
    g_wins: 'G-W',
    shutout: 'SO',
    goals_goalie: 'G-G',
    assists_goalie: 'G-A',
    standing_note:
      '* Please note that the points are already factored into the table. For example, a goalie win will automatically show 2 instead of 1',
    'standing_note.live':
      '* Please note that goalie statistics are not counted in live stats. Points are already factored into the table. For example, a defenseman goal will automatically show 2 instead of 1.',
    'my.position': 'My position:',
    'of.total': 'of',
    points: 'P',
    ppg: 'PPG',
    'plus.minus': '+/-',
    ppp: 'PPP',
    shp: 'SHP',
    gwg: 'GWG',
    pim: 'PIM',
    wins: 'W',
    losses: 'L',
    shutouts: 'SO',
    'save.percentage': 'SV%',
    players: 'Players',

    // Demotion Limits
    'demotion.limit.reached': 'Demotion limit reached ({current}/{max})',
    'season.maximum': 'Season maximum',
    'used.demotions': 'Used',
    'demotions.title': 'Demotions',
    'demotion.settings': 'Demotion Settings',
    'max.demotions.per.season': 'Maximum demotions per season',
    'demotion.settings.description': 'Limits the number of players that can be demoted during the season',

    // Season Limits
    'season.limits': 'Season Limits',
    'max.signings.per.season': 'Maximum signings per season',
    'signing.settings.description': 'Limits the number of players that can be signed during the season',
    'count.fa.signings.label': 'Count free agent signings towards the limit',
    'count.fa.signings.description': 'Determines whether free agent signings are counted against the league signing limit.',
    'tslh.signing.limit.intro': 'You are allowed a maximum of',
    'tslh.signing.limit.count': '2 signings per month',
    'tslh.signing.limit.instructions': '. To sign a player, you must first release a player or place a player on LTIR to make room in your lineup. You can then complete your signing in the section',
    'tslh.signing.limit.section': 'Free Agents',
    'unlimited.fa.signings.title': 'Unlimited free agent signings until the start of the season',
    'unlimited.fa.signings.message': 'Until the start of the season, you can sign an unlimited number of free agents. These signings are not counted against your signing limit.',
    'unlimited.fa.signings.card.title': 'Unlimited signings',
    'unlimited.fa.signings.card.subtitle': 'Until the start of the season',
    'max.signing.limit.reached': 'You have reached your season limit for player signings',
    'release.blocked.no.movement': 'You cannot release a player: you have no movements left ({current}/{max} signings used). Releasing only makes sense to free a spot for a signing. You can still reactivate an injured player without losing a signing: the option will be presented to you.',
    'season.no.movement.toggle': 'Block lineup changes during a time window',
    'season.no.movement.description': 'Prevents GMs from editing their lineup between the selected hours.',
    'season.no.movement.start': 'Blocking start hour (0-23)',
    'season.no.movement.end': 'Blocking end hour (0-23)',
    'season.no.movement.validation.range': 'Blocking hours must be whole numbers between 0 and 23.',
    'season.no.movement.validation.distinct': 'Start and end hours must be different.',

    // Trade Page
    'trade.players': 'Trade Players',
    'propose.trade': 'Propose a trade with another GM',
    'your.team': 'Your Team',
    'opponent.team': 'Opponent Team',
    'select.opponent': 'Select opponent',
    'your.players': 'Your Players',
    'your.goalies': 'Your Goalies',
    'opponent.players': 'Opponent Players',
    'opponent.goalies': 'Opponent Goalies',
    'your.trade.offer': 'Your Trade Offer',
    'opponent.trade.offer': "Opponent's Trade Offer",
    'trade.in.progress': 'Trade in Progress',
    'add.to.trade': 'Add to trade',
    'added.to.trade': 'added to trade',
    remove: 'Remove',
    'submit.trade': 'Submit Trade',
    'select.opponent.first':
      'Please select an opponent team and add players to the trade.',
    'trade.submitted': 'Trade proposal submitted successfully!',
    'trade.error': 'An error occurred while submitting the trade.',
    'placement.modal.title': 'Placement of Received Players',
    'placement.help.proposer': 'If the trade is accepted, where do you want to place each player you will receive?',
    'placement.help.accepter': 'Where do you want to place each player you are receiving in this trade?',
    'placement.main.club': 'Main Club',
    'placement.reserves': 'Reserves',
    'placement.confirm.proposer': 'Confirm & Submit Trade',
    'placement.confirm.accepter': 'Confirm & Accept Trade',
    contract: 'Contract',
    years: 'years',

    // League Settings Page
    'league.settings.title': 'League Settings',
    'salary.cap.settings': 'Salary Cap Settings',
    'main.club.salary.cap': 'Main Club Salary Cap',
    'enable.salary.cap': 'Enable Salary Cap',
    'salary.cap.amount': 'Salary Cap Amount',
    'default.amount': 'Default amount',
    'reserve.team.salary.cap': 'Reserve Team Salary Cap',
    'enable.reserve.salary.cap': 'Enable Reserve Salary Cap',
    'reserve.cap.amount': 'Reserve Cap Amount',
    'salary.retain.settings': 'Salary Retention',
    'salary.retain.toggle': 'Enable salary retention for the current season',
    'salary.retain.description': 'Allows teams to retain part of a player salary in trades for the ongoing season only.',
    'salary.retain.reset': 'Reset salary retentions',
    'salary.retain.reset.helper': 'Use this to clear every active salary retention entry for the current season.',
    'salary.retain.reset.placeholder': 'Resetting salary retention will be available soon.',
    'salary.retain.percentage': 'Salary Retention (%)',
    'salary.retain.input.label': 'Retain % of salary',
    'salary.retain.input.helper': 'Enter percentage (0-100) of salary to retain for this season only',
    'salary.retention.debt': 'Retention Debt',
    'salary.retention.debt.total': 'Total payable',
    'salary.retention.received': 'Retention received',
    'salary.retention.effective': 'Effective salary',
    'salary.retention.original': 'Original salary',
    'salary.retention.amount': 'Retained amount',
    'salary.retention.already.exists': 'This player already has an active retention',
    'salary.retention.cannot.add': 'Cannot retain salary for {playerName}: this player already has an active retention of {pct}%',
    'team.composition': 'Team Composition',
    'number.forwards': 'Number of Forwards',
    'number.defensemen': 'Number of Defensemen',
    'number.goalies': 'Number of Goalies',
    'number.reserves': 'Number of Reserve Players',
    'save.changes': 'Save Changes',
    'saving.changes': 'Saving changes...',
    'settings.saved': 'Settings saved successfully',
    'settings.error': 'Failed to save settings',
    'access.denied': 'Access Denied',
    'commissioner.only':
      'You must be the league commissioner or second commissioner to access this page',
    'league.settings.readonly.message': 'You can view the league settings but cannot modify them. Contact a commissioner to make changes.',
    'second.commissioner': 'Second Commissioner',
    'select.second.commissioner': 'Select a second commissioner',
    'no.second.commissioner': 'No second commissioner selected',
    'commissioner.management': 'Commissioner Management',
    'choose.from.league.members': 'Choose from league members',
    'second.commissioner.rights': 'The second commissioner has the same rights as the main commissioner',
    'return.office': 'Return to Office',

    // Standings Page
    'league.standings': 'League Standings',
    rank: 'Position',
    'total.points': 'Total Points',
    'loading.standings': 'Loading standings...',
    'failed.load.standings': 'Failed to load standings',
    'monthly.standings': 'Monthly Standings',
    'monthly.standings.select': 'Select a month',
    'monthly.standings.empty': 'No data available for this month.',
    'monthly.standings.error': 'Failed to load monthly standings.',
    'monthly.standings.no_months': 'No month available yet.',
    'monthly.standings.start_note': 'The monthly standings start in October to avoid issues.',
    'scoring.system': 'Scoring System',
    'forwards.scoring': 'Forwards Scoring',
    'defensemen.scoring': 'Defensemen Scoring',
    'goalies.scoring': 'Goalies Scoring',
    'forward.goal': 'Goal',
    'forward.assist': 'Assist',
    'defense.goal': 'Goal',
    'defense.assist': 'Assist',
    'goalie.win': 'Win',
    'goalie.shutout': 'Shutout',
    'goalie.goal': 'Goal',
    point: 'point',
    pointsText: 'points',

    // Free Agents Page
    'free.agents.title': 'Free Agents',
    'filter.name': 'Filter by Player Name',
    'search.player': 'Search by player name',
    'filter.team': 'Filter by Team',
    'all.teams': 'All Teams',
    'league.info': 'League Information',
    'roster.info': 'Roster Information',
    'salary.info': 'Salary Information',
    available: 'Available',
    sign: 'Sign',
    'sign.player': 'Sign {playerName}',
    'where.assign': 'Where do you want to assign {playerName}?',
    'cannot.sign.forward':
      'Cannot sign player. Forward roster limit ({limit}) reached.',
    'cannot.sign.defender':
      'Cannot sign player. Defensemen roster limit ({limit}) reached.',
    'cannot.sign.goalie':
      'Cannot sign player. Goalie roster limit ({limit}) reached.',
    'cannot.sign.salary.cap':
      'Cannot sign player. This would exceed the salary cap by {amount}',
    'cannot.sign.reserve.cap':
      'Cannot sign player. This would exceed the reserve salary cap by {amount}',
    'cannot.sign.reserve.limit':
      'Cannot sign player. Reserve roster limit ({limit}) reached.',
    'signed.success': 'You have signed {playerName}!',
    'no.free.agents': 'No free agents available for the selected filters.',
    'no.free.goalies': 'No free agent goalies available for the selected filters.',
    'loading.free.agents': 'Loading free agents...',
    'failed.load.agents': 'Failed to load free agents',
    'failed.sign.player': 'Failed to sign player',

    // Watchlist
    'watchlist.title': 'Watchlist',
    'watchlist.watched.players': 'Watched Players',
    'watchlist.all.free.agents': 'All Free Agents',
    'watchlist.no.players': 'No players being watched',
    'watchlist.add.instruction': 'Click the eye icon in the free agents list to watch a player',
    'watchlist.add.to': 'Watch this player',
    'watchlist.remove.from': 'Remove from watchlist',
    'watchlist.added.success': '{playerName} added to your watchlist',
    'watchlist.removed.success': '{playerName} removed from your watchlist',
    'watchlist.add.error': 'Error adding to watchlist',
    'watchlist.remove.error': 'Error removing from watchlist',
    'watchlist.already.exists': 'This player is already in your watchlist',
    'watchlist.added.on': 'Added on',
    'watchlist.player.count': '{count} player{count > 1 ? \'s\' : \'\'} watched',

    // Buttons
    back: 'Back',
    logout: 'Logout',

    // General
    welcome: 'Welcome, {username}!',

    // Message Center
    'message.center': 'Message Center',
    'trade.offers': 'Trade Offers',
    'league.messages': 'League Messages',
    'join.requests': 'Join Requests',
    'roster.violations': 'Roster Violations',
    'unresolved.violations': 'Unresolved violations',
    'no.trade.offers': 'No trade offers at the moment.',
    'no.league.messages': 'No league messages at the moment.',
    'no.join.requests': 'No pending join requests at the moment.',
    'waiting.response': "Waiting for {username}'s response...",
    'trade.accepted': 'Trade accepted successfully!',
    'trade.rejected': 'Trade rejected',
    'trade.cancelled': 'Trade offer cancelled successfully',
    'failed.process.trade': 'Failed to process trade',
    'failed.cancel.trade': 'Failed to cancel trade offer',
    'cancel.trade': 'Cancel Offer',
    approve: 'Approve',
    reject: 'Reject',
    processing: 'Processing...',
    'approved.request': "Approved {username}'s request to join the league",
    'rejected.request': "Rejected {username}'s request to join the league",
    'failed.approve': 'Failed to approve join request',
    'failed.reject': 'Failed to reject join request',
    'trade.deadline': 'Trade Deadline',
    'trade.completed': 'Trade Completed',
    'new.record': 'New League Record',
    announcement: 'Announcement',
    achievement: 'Achievement',

    // Trade Card Translations
    'offered.assets': 'Offered Assets',
    'requested.assets': 'Requested Assets',
    'error.receiver.salary.cap':
      "Cannot accept trade. {username}'s main club would exceed the salary cap by {excess}",
    'error.sender.salary.cap':
      "Cannot accept trade. {username}'s main club would exceed the salary cap by {excess}",
    'error.receiver.reserve.cap':
      "Cannot accept trade. {username}'s reserve team would exceed the salary cap by {excess}",
    'error.sender.reserve.cap':
      "Cannot accept trade. {username}'s reserve team would exceed the salary cap by {excess}",
    'error.receiver.forward.limit':
      "Cannot accept trade. {username}'s main club would exceed the forward limit ({limit})",
    'error.sender.forward.limit':
      "Cannot accept trade. {username}'s main club would exceed the forward limit ({limit})",
    'error.receiver.defender.limit':
      "Cannot accept trade. {username}'s main club would exceed the defender limit ({limit})",
    'error.sender.defender.limit':
      "Cannot accept trade. {username}'s main club would exceed the defender limit ({limit})",
    'error.receiver.goalie.limit':
      "Cannot accept trade. {username}'s main club would exceed the goalie limit ({limit})",
    'error.sender.goalie.limit':
      "Cannot accept trade. {username}'s main club would exceed the goalie limit ({limit})",
    'error.receiver.reserve.limit':
      "Cannot accept trade. {username}'s reserve team would exceed the player limit ({limit})",
    'error.sender.reserve.limit':
      "Cannot accept trade. {username}'s reserve team would exceed the player limit ({limit})",
    'failed.load.trades': 'Failed to load trade offers',
    'failed.load.requests': 'Failed to load join requests',

    // League Privacy Settings
    'league.privacy.settings': 'League Privacy Settings',
    'private.league': 'Private League',
    'public.league': 'Public League',
    'private.league.description':
      'Only invited members can join this league',
    'public.league.description': 'Anyone can join this league',

    'pending.requests': 'pending requests',

    // Join League Page
    'join.league.page': 'Join League',
    loading: 'Loading...',
    'no.leagues.available':
      'No leagues available to join at the moment.',
    'created.on': 'Created {date}',
    'send.request': 'Send Request',
    'request.sent': 'Request sent to join {name}',
    'already.member': 'You are already a member of {name}',
    'joined.success': 'Successfully joined {name}!',
    'failed.join': 'Failed to join league',
    'failed.load.leagues': 'Failed to load available leagues',

    // Create League Page
    'create.league.title': 'Create New League',
    'league.name': 'League Name',
    'league.privacy': 'League Privacy',
    'make.private': 'Make this league private',
    'private.description':
      'Private leagues are only visible to invited members',
    'creating.league': 'Creating league...',
    'league.created': 'League created successfully!',
    'failed.create.league':
      'An error occurred while creating the league',

    // System Recommendations
    'system.recommendations': 'System Recommendations',
    'submit.recommendations': 'Submit ideas to improve the system',
    'recommendation.category': 'Category',
    'category.general': 'General Improvement',
    'category.trading': 'Trading System',
    'category.roster': 'Roster Management',
    'category.scoring': 'Scoring System',
    'category.interface': 'User Interface',
    'recommendation.description': 'Your Recommendation',
    'recommendation.placeholder': 'Describe your suggestion in detail...',
    'send.recommendation': 'Send Recommendation',
    sending: 'Sending...',
    'recommendation.sent': 'Thank you! Your recommendation has been sent.',
    'recommendation.error': 'Failed to send recommendation',
    'recommendation.guidelines': 'Guidelines for Good Recommendations',
    'guideline.clear': 'Be clear and detailed in your explanation',
    'guideline.specific':
      'Focus on specific features or improvements',
    'guideline.constructive': 'Provide constructive feedback',

    // Join request notifications
    'join.request.received': 'New join request received from {username}',
    'join.request.notification': 'You have received a new join request for {leagueName}',

    // Advanced Search
    'advanced.search.title': 'Advanced Player Search',
    'advanced.search.filters': 'Search Filters',
    'advanced.search.min.salary': 'Min Salary',
    'advanced.search.max.salary': 'Max Salary',
    'advanced.search.min.points': 'Min Points',
    'advanced.search.max.points': 'Max Points',
    'advanced.search.min.goals': 'Min Goals',
    'advanced.search.max.goals': 'Max Goals',
    'advanced.search.min.assists': 'Min Assists',
    'advanced.search.max.assists': 'Max Assists',
    'advanced.search.min.age': 'Min Age',
    'advanced.search.max.age': 'Max Age',
    'advanced.search.min.years': 'Min Years',
    'advanced.search.max.years': 'Max Years',
    'advanced.search.status': 'Status',
    'advanced.search.ownership': 'Ownership',
    'advanced.search.all.players': 'All Players',
    'advanced.search.free.agents.only': 'Free Agents Only',
    'advanced.search.owned.only': 'Owned Players Only',
    'advanced.search.results': 'Results',
    'advanced.search.no.results': 'No players found with these criteria.',
    'advanced.search.loading': 'Searching...',
    'advanced.search.sort.by': 'Sort by',
    'advanced.search.apply.filters': 'Apply Filters',
    'advanced.search.reset.filters': 'Reset',
  },
  fr: {
    // Auth
    'welcome.back': 'Bon Retour!',
    'join.pool': 'Rejoindre Dynasty Hockey Pool',
    'need.account': "Besoin d'un compte? Inscrivez-vous",
    'have.account': 'Déjà un compte? Connectez-vous',
    'email.address': 'Adresse courriel',
    password: 'Mot de passe',
    username: "Nom d'utilisateur",
    'date.of.birth': 'Date de naissance',
    'create.account': 'Créer un Compte',
    'creating.account': 'Création du compte...',
    login: 'Se Connecter',
    'logging.in': 'Connexion...',
  'remember.me': 'Se souvenir de moi',
    'account.created': 'Compte créé avec succès!',
    'registration.error': "Une erreur est survenue lors de l'inscription",
    'registration.email.exists': 'Un compte avec cet email existe déjà',

  // Password reset
  'forgot.password': 'Mot de passe oublié?',
  'new.password': 'Nouveau mot de passe',
  'reset.password': 'Réinitialiser le mot de passe',
  'updating.password': 'Mise à jour du mot de passe...',
  'password.updated': 'Mot de passe mis à jour',
  'password.update.failed': 'Échec de la mise à jour du mot de passe',
  'email.not.found': "Courriel introuvable",

  // Birthdate Modal
  'complete.your.profile': 'Complétez votre profil',
  'birthdate.request.message': 'Pour améliorer votre expérience, veuillez fournir votre date de naissance.',
  'date.of.birth.required': 'La date de naissance est requise',
  'date.of.birth.updated': 'Date de naissance mise à jour avec succès!',
  'error.updating.birthdate': 'Une erreur est survenue lors de la mise à jour de votre date de naissance',
  'submitting': 'Envoi en cours',
  'submit': 'Soumettre',
  'error.user.not.found': 'Utilisateur non trouvé',

    // Dashboard
    'hockey.dynasty.dashboard': 'Tableau de Bord Dynasty Hockey',
    'welcome.user': 'Bon retour, {username}!',
    'create.new.league': 'Créer une Nouvelle Ligue',
    'select.my.league': 'Sélectionner Ma Ligue',
    'join.league': 'Rejoindre une Ligue',

    // My Leagues
    'my.leagues': 'Mes Ligues',
    'no.leagues.yet': "Vous n'avez pas encore rejoint de ligue.",
    'create.league.button': 'Créer une Nouvelle Ligue',
    'join.existing.league': 'Rejoindre une Ligue Existante',
    'welcome.to.dynasty': 'Bienvenue sur Dynasty Hockey Pool',
    'start.journey':
      'Commencez votre aventure en créant une nouvelle ligue ou en rejoignant une ligue existante',

    // General Manager Office
    'gm.office': 'Bureau du Directeur Général',
    'my.team': 'Mon Équipe',
    'manage.team': "Gérer l'effectif et l'alignement de votre équipe",
    'free.agents': 'Agents Libres',
    'browse.agents': 'Parcourir et signer les joueurs disponibles',
    standings: 'Classement',
    'view.standings': 'Voir les statistiques et le classement de la ligue',
    waivers: 'Ballottage',
    'players.waivers': 'Joueurs disponibles au ballottage',
    'trade.center': 'Centre des Échanges',
    'manage.trades': 'Proposer et gérer les échanges',
    messages: 'Messages',
    'league.communications': 'Communications et notifications de la ligue',
    'league.rules': 'Règlements',
    'view.rules': 'Consulter les règlements et paramètres de la ligue',
    'league.settings': 'Paramètres de la Ligue',
    'configure.settings': 'Configurer les paramètres de la ligue',
    'coming.soon': 'Bientôt disponible',
    'protection.list': 'Liste de Protection',
    'manage.protection.list': 'Gérer votre liste de joueurs protégés',

  // Leave League
  'leave.league.description': 'En quittant la ligue, votre équipe sera confiée temporairement au DG tutelle. Vos joueurs, choix au repêchage et points au classement seront conservés jusqu\'à l\'arrivée du prochain DG et votre abonnement annuel sera annulé automatiquement.',
  'leave.league.button': 'Quitter la ligue (dernière option)',
  'leave.league.tooltip': 'Quitter la ligue et transférer l\'équipe au DG tutelle',
  'leave.league.note.default': 'Votre abonnement récurrent sera annulé automatiquement; contactez le commissaire pour toute question de remboursement.',
  'leave.league.note.commissioner': 'Les commissaires doivent transférer leurs droits avant de pouvoir quitter la ligue.',
  'leave.league.modal.title': 'Confirmer la sortie de la ligue',
  'leave.league.modal.body': 'Êtes-vous sûr de vouloir quitter la ligue "{leagueName}" ? Votre équipe sera transférée au DG tutelle, vos joueurs resteront sous contrat, vos points au classement seront conservés et votre abonnement annuel sera annulé automatiquement.',
  'leave.league.modal.irreversible': 'Cette action est irréversible.',
  'leave.league.modal.cancel': 'Annuler',
  'leave.league.modal.confirm': 'Confirmer et quitter la ligue',
  'leave.league.modal.progress': 'Transfert en cours...',
  'leave.league.error.commissioner': 'Un commissaire doit transférer ses droits avant de quitter la ligue.',
  'leave.league.error.invalidUser': 'Identifiant utilisateur invalide.',
  'leave.league.error.generic': 'Impossible de quitter la ligue.',
  'leave.league.error.unexpected': 'Une erreur inattendue est survenue lors de la sortie de la ligue.',
  'leave.league.success': 'Votre équipe a été confiée au DG tutelle.',
  'leave.league.cta.title': 'Quitter la ligue et transférer l\'équipe au DG tutelle',

    // Guardian assignment
    'league.guardian.assignment.title': "Attribuer l'équipe tutelle",
    'league.guardian.assignment.description': 'Sélectionnez un DG qui reprendra immédiatement la formation gérée par le DG tutelle.',
    'league.guardian.assignment.currentTeam': 'Équipe tutelle actuelle',
    'league.guardian.assignment.teamFallback': 'DG tutelle',
    'league.guardian.assignment.select': 'Choisir le nouveau DG',
    'league.guardian.assignment.placeholder': '-- Sélectionnez un DG sans équipe --',
    'league.guardian.assignment.helper': "Seuls les DG sans équipe active peuvent recevoir l'équipe tutelle.",
    'league.guardian.assignment.cta': "Attribuer l'équipe tutelle",
    'league.guardian.assignment.loading': 'Attribution en cours...',
    'league.guardian.assignment.noCandidates': "Aucun DG admissible sans équipe n'est disponible pour le moment.",
    'league.guardian.assignment.noGuardian': "Aucune équipe tutelle n'est disponible dans cette ligue.",
    'league.guardian.assignment.success': "L'équipe tutelle a été transférée au DG sélectionné!",
    'league.guardian.assignment.error': "Impossible d'attribuer l'équipe tutelle.",
    'league.guardian.assignment.error.generic': "Une erreur est survenue lors de l'attribution de l'équipe tutelle.",

  // Player Detail Page
  'player.detail.back': 'Retour',
  'player.detail.open.nhl': 'Ouvrir le profil NHL.com',
  'player.detail.invalid.id': 'Identifiant de joueur invalide',
  'player.detail.fetch.error': 'Impossible de charger les détails du joueur',
  'player.detail.fetch.timeout': 'L’API de la LNH met trop de temps à répondre',
  'player.detail.fetch.fallback': 'Impossible de charger ce joueur pour le moment. Réessayez plus tard.',
  'player.detail.team.unknown': 'Équipe inconnue',
  'player.detail.position': 'Position',
  'player.detail.position.unknown': 'Inconnue',
  'player.detail.biography': 'Biographie',
  'player.detail.height': 'Taille',
  'player.detail.height.cm': 'cm',
  'player.detail.weight': 'Poids',
  'player.detail.weight.kg': 'kg',
  'player.detail.weight.lbs': 'lb',
  'player.detail.shoots': 'Tire/Capte',
  'player.detail.shoots.left': 'Gauche',
  'player.detail.shoots.right': 'Droite',
  'player.detail.shoots.catch': 'Attrape',
  'player.detail.draft': 'Repêchage',
  'player.detail.birthplace': 'Lieu de naissance',
  'player.detail.contract': 'Informations contractuelles',
  'player.detail.salary': 'Salaire',
  'player.detail.years.left': 'Années',
  'player.detail.years.left.value': '{years} année(s)',
  'player.detail.key.stats': 'Statistiques clés',
  'player.detail.regular.season': 'Saison régulière',
  'player.detail.regular.season.short': 'Saison',
  'player.detail.playoffs': 'Séries éliminatoires',
  'player.detail.playoffs.short': 'Séries',
  'player.detail.stat.label': 'Statistique',
  'player.detail.stat.season': 'Saison en cours',
  'player.detail.stat.career': 'Carrière',
  'player.detail.last.games': '5 derniers matchs',
  'player.detail.last.games.subtitle': 'Saison régulière et séries combinées',
  'player.detail.opponent': 'Adversaire',
  'player.detail.plusminus.short': '+/-',
  'player.detail.decision': 'Décision',
  'player.detail.decision.win': 'Victoire',
  'player.detail.decision.loss': 'Défaite',
  'player.detail.decision.ot': 'Défaite en prolongation',
  'player.detail.decision.so': 'Défaite en fusillade',
  'player.detail.toi': 'TJG',
  'player.detail.no.games': 'Aucun match récent disponible',
  'player.detail.current.roster': 'Effectif actuel de l’équipe',
  'player.detail.not.available': 'Non disponible',
  'player.detail.round': 'Ronde',
  'player.detail.pick.suffix': 'e au total',
  'player.detail.career.totals': 'Totaux en carrière',
  'player.detail.awards': 'Trophées et récompenses',
  'player.detail.awards.none': 'Aucun trophée répertorié pour le moment',
  'player.detail.season.stats': 'Statistiques par saison',
  'player.detail.select.season': 'Sélectionner la saison',
  'player.detail.historical.stats': 'Statistiques historiques',
  'player.detail.current.season': 'Saison actuelle',
  'player.detail.loading.season': 'Chargement des données de la saison...',
  'player.detail.no.season.data': 'Aucune donnée disponible pour cette saison',

  // Tableau de bord analytique joueur
  'player.detail.analytics.title': 'Tableau de bord analytique',
  'player.detail.analytics.chart': 'Graphique de performance',
  'player.detail.analytics.contract': 'Contrat vs Production',
  'player.detail.analytics.transactions': 'Historique des transactions',
  'player.detail.analytics.no.league': 'Sélectionnez une ligue pour voir les transactions',
  'player.detail.analytics.no.transactions': 'Aucune transaction trouvée pour ce joueur',
  'player.detail.analytics.trade.sent': 'Échangé à {username}',
  'player.detail.analytics.trade.received': 'Reçu de {username}',
  'player.detail.analytics.signing': 'Signé par {username}',
  'player.detail.analytics.chart.nhl.only': 'Saison régulière NHL seulement',

  // NHL Edge Stats section
  'nhl.edge.title': 'Statistiques NHL Edge™',
  'nhl.edge.subtitle': 'Données de performance avancées propulsées par la technologie NHL Edge',
  'nhl.edge.game.type.regular': 'Saison régulière',
  'nhl.edge.game.type.playoffs': 'Éliminatoires',
  'nhl.edge.loading': 'Chargement des données NHL Edge…',
  'nhl.edge.error.unavailable': 'Données NHL Edge indisponibles pour ce joueur',
  'nhl.edge.error.no.data': 'Aucune donnée NHL Edge trouvée pour cette saison',
  'nhl.edge.rank.of': 'sur',
  'nhl.edge.rank.label': 'Rang',
  'nhl.edge.percentile': 'percentile',
  // Métriques patineur
  'nhl.edge.skating.speed.title': 'Vitesse de patinage',
  'nhl.edge.skating.speed.max': 'Vitesse maximale',
  'nhl.edge.skating.speed.bursts22': 'Accélérations ≥ 22 mph',
  'nhl.edge.skating.speed.bursts20': 'Accélérations 20–22 mph',
  'nhl.edge.skating.speed.unit': 'mph',
  'nhl.edge.shot.speed.title': 'Vitesse de tir',
  'nhl.edge.shot.speed.max': 'Vitesse maximale',
  'nhl.edge.shot.speed.unit': 'mph',
  'nhl.edge.distance.title': 'Distance parcourue',
  'nhl.edge.distance.total': 'Distance totale',
  'nhl.edge.distance.avg': 'Moy. par match',
  'nhl.edge.distance.unit': 'km',
  'nhl.edge.zone.time.title': 'Temps en zone',
  'nhl.edge.zone.time.offensive': 'Zone offensive',
  'nhl.edge.zone.time.neutral': 'Zone neutre',
  'nhl.edge.zone.time.defensive': 'Zone défensive',
  'nhl.edge.shot.location.title': 'Tirs au but par zone',
  'nhl.edge.shot.location.high.danger': 'Haute danger',
  'nhl.edge.shot.location.mid.range': 'Moyenne portée',
  'nhl.edge.shot.location.long.range': 'Longue portée',
  'nhl.edge.shot.location.sog': 'TB',
  'nhl.edge.shot.location.goals': 'Buts',
  'nhl.edge.shot.location.pctg': 'Tir%',
  // Métriques gardien
  'nhl.edge.goalie.gaa.title': 'Moyenne de buts alloués',
  'nhl.edge.goalie.games.above.900': 'Matchs au-dessus de ,900',
  'nhl.edge.goalie.goal.differential': 'Différentiel buts / 60 min',
  'nhl.edge.goalie.goal.support': 'Soutien offensif moyen (but / match)',
  'nhl.edge.goalie.point.pctg': '% de victoire',
  'nhl.edge.goalie.shot.location.title': 'Arrêts par zone de tir',
  'nhl.edge.goalie.saves': 'Arrêts',
  'nhl.edge.goalie.goals.against': 'Buts accordés',
  'nhl.edge.goalie.save.pctg': '% arrêts',
  'nhl.edge.no.goalie.data': 'Aucune donnée NHL Edge disponible pour ce gardien',

  'player.detail.contract.underpaid': '🟢 Sous-payé',
  'player.detail.contract.fair': '🟡 Juste valeur',
  'player.detail.contract.overpaid': '🔴 Sur-payé',
  'player.detail.contract.unknown': '⚪ Manque de données',

  // Player Detail Stats labels
  'stat.gamesPlayed': 'Matchs joués',
  'stat.goals': 'Buts',
  'stat.assists': 'Passes',
  'stat.points': 'Points',
  'stat.plusMinus': 'Différence de buts',
  'stat.powerPlayGoals': 'Buts en avantage numérique',
  'stat.powerPlayPoints': 'Points en avantage numérique',
  'stat.shorthandedGoals': 'Buts en désavantage numérique',
  'stat.shorthandedPoints': 'Points en désavantage numérique',
  'stat.gameWinningGoals': 'Buts gagnants',
  'stat.shots': 'Tirs',
  'stat.shootingPctg': 'Pourcentage de tirs',
  'stat.pim': 'Minutes de punition',
  'stat.avgToi': 'Temps de jeu moyen',
  'stat.faceoffWinningPctg': 'Taux de victoires aux mises en jeu',
  'stat.wins': 'Victoires',
  'stat.losses': 'Défaites',
  'stat.otLosses': 'Défaites en prolongation',
  'stat.goalsAgainst': 'Buts alloués',
  'stat.goalsAgainstAvg': 'Moyenne de buts alloués',
  'stat.savePctg': "Pourcentage d'arrêts",
  'stat.savePctg.short': 'EFF%',
  'stat.shutouts': 'Jeux blancs',
  'stat.shotsAgainst': 'Tirs reçus',
  'stat.saves': 'Arrêts',
  date: 'Date',

    // Draft System
    'draft.title': 'Repêchage de la Ligue',
    'draft.pick': 'Choix de repêchage',
    'draft.not.available': 'Système de Repêchage Bientôt Disponible',
    'draft.messenger.info':
      'Pour le moment, veuillez créer un groupe Messenger avec tous les membres de la ligue pour effectuer le repêchage à tour de rôle efficacement.',
    'draft.create.group':
      'Cela garantit que tout le monde peut participer en temps réel et rend le processus de repêchage plus fluide.',

    // Protection List Settings
    'protection.list.settings': 'Liste de Protection Fin de Saison',
    'number.forwards.protect': "Nombre d'Attaquants à Protéger",
    'number.defensemen.protect': 'Nombre de Défenseurs à Protéger',
    'number.goalies.protect': 'Nombre de Gardiens à Protéger',

    // My Team Page
    'my.team.title': 'Mon Équipe',
    'roster.limits': "Limites de l'Effectif",
    forwards: 'Attaquants',
    defensemen: 'Défenseurs',
    goalies: 'Gardiens',
    'reserve.players': 'Joueurs Réserves',
    'salary.cap.usage': 'Utilisation du Plafond Salarial',
    current: 'Actuel',
    maximum: 'Maximum',
    'main.club': 'Club Principal',
    reserves: 'Réserves',
    scratch: 'Joueurs Scratch',
    'scratch.player': 'Joueur Scratch',
    'filter.position': 'Filtrer par Position',
    'all.positions': 'Toutes les Positions',
    'forwards.crl': 'Attaquants (C/AG/AD)',
    defense: 'Défense',
    center: 'Centre',
    'left.wing': 'Ailier Gauche',
    'right.wing': 'Ailier Droit',
    defenseman: 'Défenseur',
    'no.players.available':
      'Aucun joueur disponible dans {section} pour la position sélectionnée.',
    'no.goalies.available': 'Aucun gardien disponible dans {section}.',
    previous: 'Précédent',
    next: 'Suivant',
    page: 'Page',
    of: 'sur',
    release: 'Libérer',
    promote: 'Promouvoir',
    demote: 'Rétrograder',
    name: 'Nom',
    position: 'Position',
    team: 'Équipe',
    salary: 'Salaire',
    'selection.percentage': '%sél.',
    'years.left': 'Années Restantes',
    gp: 'PJ',
    goals: 'B',
    assists: 'A',
    g_wins: 'V-G',
    shutout: 'BL',
    goals_goalie: 'B-G',
    assists_goalie: 'A-G',
    standing_note:
      ' * À noter que les points sont déjà calculés dans la grille. Par exemple, une victoire de gardien affichera déjà 2 au lieu de 1',
    'standing_note.live':
      '* À noter que les statistiques des gardiens ne sont pas comptabilisées dans les stats live. Les points sont déjà calculés dans la grille. Par exemple, un but de défenseur affichera déjà 2 au lieu de 1.',
    'my.position': 'Ma position :',
    'of.total': 'sur',
    points: 'P',
    ppg: 'PPP',
    'plus.minus': '+/-',
    ppp: 'BPP',
    shp: 'BDI',
    gwg: 'BV',
    pim: 'PÉN',
    wins: 'V',
    losses: 'D',
    shutouts: 'JB',
    'save.percentage': '%ARR',
    players: 'Joueurs',

    // Demotion Limits
    'demotion.limit.reached': 'Limite de rétrogradation atteinte ({current}/{max})',
    'season.maximum': 'Maximum par saison',
    'used.demotions': 'Utilisées',
    'demotions.title': 'Rétrogradations',
    'demotion.settings': 'Paramètres de Rétrogradation',
    'max.demotions.per.season': 'Nombre maximal de rétrogradations par saison',
    'demotion.settings.description': 'Limite le nombre de joueurs qui peuvent être rétrogradés durant la saison',

    // Season Limits
    'season.limits': 'Limites de la Saison',
    'max.signings.per.season': 'Nombre maximal de signatures par saison',
    'signing.settings.description': 'Limite le nombre de joueurs qui peuvent être signés durant la saison',
    'count.fa.signings.label': 'Compter les signatures d\'agents libres dans la limite',
    'count.fa.signings.description': 'Détermine si les signatures d\'agents libres sont comptabilisées dans la limite de signatures de la ligue.',
    'tslh.signing.limit.intro': 'Vous avez droit à un maximum de',
    'tslh.signing.limit.count': '2 signatures par mois',
    'tslh.signing.limit.instructions': '. Pour signer un joueur, vous devez d’abord libérer un joueur ou placer un joueur sur la LTIR afin de faire de la place dans votre alignement. Vous pourrez ensuite effectuer votre signature dans la section',
    'tslh.signing.limit.section': 'Agents libres',
    'unlimited.fa.signings.title': 'Signatures d\'agents libres illimitées jusqu\'au 7 Octobre minuit',
    'unlimited.fa.signings.message': 'Jusqu’au 7 octobre à minuit, mouvements illimités et points basés sur le total accumulé depuis le début de la saison. Dès le 8 octobre, les règles normales s’appliquent et seuls les points de la journée sont comptabilisés.',
    'unlimited.fa.signings.card.title': 'Signatures illimitées',
    'unlimited.fa.signings.card.subtitle': 'Jusqu\'au 7 Octobre minuit',
    'max.signing.limit.reached': 'Vous avez atteint votre limite saisonnière de signatures de joueurs',
    'release.blocked.no.movement': 'Libération impossible : vous n\'avez plus de mouvement disponible ({current}/{max} signatures utilisées). Libérer un joueur ne sert qu\'à faire de la place pour une signature. Vous pouvez toutefois réactiver un joueur blessé sans perdre de signature : l\'option vous sera présentée.',
    'season.no.movement.toggle': "Bloquer les modifications d'alignement durant une plage horaire",
    'season.no.movement.description': 'Empêche les DG de modifier leur alignement entre les heures définies.',
    'season.no.movement.start': 'Heure de début du blocage (0-23)',
    'season.no.movement.end': 'Heure de fin du blocage (0-23)',
    'season.no.movement.validation.range': 'Les heures de blocage doivent être des valeurs entières entre 0 et 23.',
    'season.no.movement.validation.distinct': "L'heure de début et de fin du blocage doivent être différentes.",

    // Trade Page
    'trade.players': 'Échanger des Joueurs',
    'propose.trade': 'Proposer un échange avec un autre DG',
    'your.team': 'Votre Équipe',
    'opponent.team': 'Équipe Adverse',
    'select.opponent': "Sélectionner l'équipe adverse",
    'your.players': 'Vos Joueurs',
    'your.goalies': 'Vos Gardiens',
    'opponent.players': 'Joueurs Adverses',
    'opponent.goalies': 'Gardiens Adverses',
    'your.trade.offer': "Mon équipe",
    'opponent.trade.offer': "Équipe adverse",
    'trade.in.progress': 'Échange en cours',
    'add.to.trade': "Ajouter à l'échange",
    'added.to.trade': "ajouté à l'échange",
    remove: 'Retirer',
    'submit.trade': "Soumettre l'échange",
    'select.opponent.first':
      "Veuillez sélectionner une équipe adverse et ajouter des joueurs à l'échange.",
    'trade.submitted': "Proposition d'échange soumise avec succès!",
    'trade.error':
      "Une erreur est survenue lors de la soumission de l'échange.",
    'placement.modal.title': 'Placement des joueurs reçus',
    'placement.help.proposer': "Si l'échange est accepté, où souhaitez-vous placer chaque joueur que vous recevrez?",
    'placement.help.accepter': 'Où souhaitez-vous placer chaque joueur que vous recevez dans cet échange?',
    'placement.main.club': 'Club Principal',
    'placement.reserves': 'Réserves',
    'placement.confirm.proposer': "Confirmer et soumettre l'échange",
    'placement.confirm.accepter': "Confirmer et accepter l'échange",
    contract: 'Contrat',
    years: 'ans',

    // League Settings Page
    'league.settings.title': 'Paramètres de la Ligue',
    'salary.cap.settings': 'Paramètres du Plafond Salarial',
    'main.club.salary.cap': 'Plafond Salarial Club Principal',
    'enable.salary.cap': 'Activer le Plafond Salarial',
    'salary.cap.amount': 'Montant du Plafond Salarial',
    'default.amount': 'Montant par défaut',
    'reserve.team.salary.cap': 'Plafond Salarial Équipe Réserve',
    'enable.reserve.salary.cap': 'Activer le Plafond Salarial Réserve',
    'reserve.cap.amount': 'Montant du Plafond Salarial Réserve',
    'salary.retain.settings': 'Retenue de salaire',
    'salary.retain.toggle': 'Activer la retenue de salaire pour la saison en cours',
    'salary.retain.description': "Permet aux équipes d'inclure une portion du salaire dans les transactions pour la saison en cours uniquement.",
    'salary.retain.reset': 'Réinitialiser les retenues de salaire',
    'salary.retain.reset.helper': 'Utilisez ce bouton pour remettre à zéro toutes les retenues de salaire actives.',
    'salary.retain.reset.placeholder': 'La réinitialisation des retenues de salaire sera disponible prochainement.',
    'salary.retain.percentage': 'Retenue de salaire (%)',
    'salary.retain.input.label': 'Retenir % du salaire',
    'salary.retain.input.helper': 'Entrez le pourcentage (0-100) du salaire à retenir pour cette saison seulement',
    'salary.retention.debt': 'Dette de Rétention',
    'salary.retention.debt.total': 'Total à payer',
    'salary.retention.received': 'Retenue reçue',
    'salary.retention.effective': 'Salaire effectif',
    'salary.retention.original': 'Salaire original',
    'salary.retention.amount': 'Montant retenu',
    'salary.retention.already.exists': 'Ce joueur a déjà une rétention active',
    'salary.retention.cannot.add': 'Impossible de retenir du salaire pour {playerName}: ce joueur a déjà une rétention active de {pct}%',
    'team.composition': "Composition de l'Équipe",
    'number.forwards': "Nombre d'Attaquants",
    'number.defensemen': 'Nombre de Défenseurs',
    'number.goalies': 'Nombre de Gardiens',
    'number.reserves': 'Nombre de Joueurs Réserves',
    'save.changes': 'Sauvegarder les Changements',
    'saving.changes': 'Sauvegarde en cours...',
    'settings.saved': 'Paramètres sauvegardés avec succès',
    'settings.error': 'Échec de la sauvegarde des paramètres',
    'access.denied': 'Accès Refusé',
    'commissioner.only':
      'Vous devez être le commissaire de la ligue ou le deuxième commissaire pour accéder à cette page',
    'league.settings.readonly.message': 'Vous pouvez consulter les paramètres de la ligue mais ne pouvez pas les modifier. Contactez un commissaire pour effectuer des changements.',
    'second.commissioner': 'Deuxième Commissaire',
    'select.second.commissioner': 'Sélectionner un deuxième commissaire',
    'no.second.commissioner': 'Aucun deuxième commissaire sélectionné',
    'commissioner.management': 'Gestion des Commissaires',
    'choose.from.league.members': 'Choisir parmi les membres de la ligue',
    'second.commissioner.rights': 'Le deuxième commissaire a les mêmes droits que le commissaire principal',
    'return.office': 'Retourner au Bureau',

    // Standings Page
    'league.standings': 'Classement de la Ligue',
    rank: 'Position',
    'total.points': 'Points Totaux',
    'loading.standings': 'Chargement du classement...',
    'failed.load.standings': 'Échec du chargement du classement',
    'monthly.standings': 'Classement mensuel',
    'monthly.standings.select': 'Sélectionner un mois',
    'monthly.standings.empty': 'Aucune donnée disponible pour ce mois.',
    'monthly.standings.error': 'Échec du chargement du classement mensuel.',
    'monthly.standings.no_months': 'Aucun mois disponible pour le moment.',
    'monthly.standings.start_note': 'Le classement mensuel débute en octobre.',
    'scoring.system': 'Système de Pointage',
    'forwards.scoring': 'Pointage des Attaquants',
    'defensemen.scoring': 'Pointage des Défenseurs',
    'goalies.scoring': 'Pointage des Gardiens',
    'forward.goal': 'But',
    'forward.assist': 'Passe',
    'defense.goal': 'But',
    'defense.assist': 'Passe',
    'goalie.win': 'Victoire',
    'goalie.shutout': 'Blanchissage',
    'goalie.goal': 'But',
    point: 'point',
    pointsText: 'points',

    // Free Agents Page
    'free.agents.title': 'Agents Libres',
    'filter.name': 'Filtrer par Nom du Joueur',
    'search.player': 'Rechercher par nom du joueur',
    'filter.team': 'Filtrer par Équipe',
    'all.teams': 'Toutes les Équipes',
    'league.info': 'Information de la Ligue',
    'roster.info': "Information de l'Effectif",
    'salary.info': 'Information Salariale',
    available: 'Disponible',
    sign: 'Signer',
    'sign.player': 'Signer {playerName}',
    'where.assign': 'Où voulez-vous assigner {playerName}?',
    'cannot.sign.forward':
      "Impossible de signer le joueur. Limite d'attaquants ({limit}) atteinte.",
    'cannot.sign.defender':
      'Impossible de signer le joueur. Limite de défenseurs ({limit}) atteinte.',
    'cannot.sign.goalie':
      'Impossible de signer le joueur. Limite de gardiens ({limit}) atteinte.',
    'cannot.sign.salary.cap':
      'Impossible de signer le joueur. Cela dépasserait le plafond salarial de {amount}',
    'cannot.sign.reserve.cap':
      'Impossible de signer le joueur. Cela dépasserait le plafond salarial des réserves de {amount}',
    'cannot.sign.reserve.limit':
      'Impossible de signer le joueur. Limite de joueurs de réserve ({limit}) atteinte.',
    'signed.success': 'Vous avez signé {playerName}!',
    'no.free.agents':
      'Aucun agent libre disponible pour les filtres sélectionnés.',
    'no.free.goalies':
      'Aucun gardien agent libre disponible pour les filtres sélectionnés.',
    'loading.free.agents': 'Chargement des agents libres...',
    'failed.load.agents': 'Échec du chargement des agents libres',
    'failed.sign.player': 'Échec de la signature du joueur',

    // Watchlist
    'watchlist.title': 'Liste de Surveillance',
    'watchlist.watched.players': 'Joueurs Surveillés',
    'watchlist.all.free.agents': 'Tous les Agents Libres',
    'watchlist.no.players': 'Aucun joueur surveillé',
    'watchlist.add.instruction': 'Cliquez sur l\'icône œil dans la liste des agents libres pour surveiller un joueur',
    'watchlist.add.to': 'Surveiller ce joueur',
    'watchlist.remove.from': 'Retirer de la surveillance',
    'watchlist.added.success': '{playerName} ajouté à votre liste de surveillance',
    'watchlist.removed.success': '{playerName} retiré de votre liste de surveillance',
    'watchlist.add.error': 'Erreur lors de l\'ajout à la liste de surveillance',
    'watchlist.remove.error': 'Erreur lors du retrait de la liste de surveillance',
    'watchlist.already.exists': 'Ce joueur est déjà dans votre liste de surveillance',
    'watchlist.added.on': 'Ajouté le',
    'watchlist.player.count': '{count} joueur{count > 1 ? \'s\' : \'\'} surveillé{count > 1 ? \'s\' : \'\'}',

    // Buttons
    back: 'Retour',
    logout: 'Déconnexion',

    // General
    welcome: 'Bienvenue, {username}!',

    // Message Center
    'message.center': 'Centre de Messages',
    'trade.offers': "Offres d'Échange",
    'league.messages': 'Messages de la Ligue',
    'join.requests': "Demandes d'Adhésion",
    'roster.violations': "Violations d'Alignement",
    'unresolved.violations': 'Violations non résolues',
    
    'no.trade.offers': "Aucune offre d'échange pour le moment.",
    'no.league.messages': 'Aucun message de la ligue pour le moment.',
    'no.join.requests': "Aucune demande d'adhésion en attente pour le moment.",
    'waiting.response': 'En attente de la réponse de {username}...',
    'trade.accepted': 'Échange accepté avec succès!',
    'trade.rejected': 'Échange refusé',
    'trade.cancelled': "Offre d'échange annulée avec succès",
    'failed.process.trade': "Échec du traitement de l'échange",
    'failed.cancel.trade': "Échec de l'annulation de l'offre d'échange",
    'cancel.trade': "Annuler l'offre",
    approve: 'Approuver',
    reject: 'Refuser',
    processing: 'Traitement en cours...',
    'approved.request': "Demande d'adhésion de {username} approuvée",
    'rejected.request': "Demande d'adhésion de {username} refusée",
    'failed.approve': "Échec de l'approbation de la demande",
    'failed.reject': 'Échec du refus de la demande',
    'trade.deadline': 'Date Limite des Échanges',
    'trade.completed': 'Échange Complété',
    'new.record': 'Nouveau Record de la Ligue',
    announcement: 'Annonce',
    achievement: 'Réalisation',

    // Trade Card Translations
    'offered.assets': 'Actifs Offerts',
    'requested.assets': 'Actifs Demandés',
    'error.receiver.salary.cap':
      "Impossible d'accepter l'échange. L'équipe principale de {username} dépasserait le plafond salarial de {excess}",
    'error.sender.salary.cap':
      "Impossible d'accepter l'échange. L'équipe principale de {username} dépasserait le plafond salarial de {excess}",
    'error.receiver.reserve.cap':
      "Impossible d'accepter l'échange. L'équipe réserve de {username} dépasserait le plafond salarial de {excess}",
    'error.sender.reserve.cap':
      "Impossible d'accepter l'échange. L'équipe réserve de {username} dépasserait le plafond salarial de {excess}",
    'error.receiver.forward.limit':
      "Impossible d'accepter l'échange. L'équipe principale de {username} dépasserait la limite d'attaquants ({limit})",
    'error.sender.forward.limit':
      "Impossible d'accepter l'échange. L'équipe principale de {username} dépasserait la limite d'attaquants ({limit})",
    'error.receiver.defender.limit':
      "Impossible d'accepter l'échange. L'équipe principale de {username} dépasserait la limite de défenseurs ({limit})",
    'error.sender.defender.limit':
      "Impossible d'accepter l'échange. L'équipe principale de {username} dépasserait la limite de défenseurs ({limit})",
    'error.receiver.goalie.limit':
      "Impossible d'accepter l'échange. L'équipe principale de {username} dépasserait la limite de gardiens ({limit})",
    'error.sender.goalie.limit':
      "Impossible d'accepter l'échange. L'équipe principale de {username} dépasserait la limite de gardiens ({limit})",
    'error.receiver.reserve.limit':
      "Impossible d'accepter l'échange. L'équipe réserve de {username} dépasserait la limite de joueurs ({limit})",
    'error.sender.reserve.limit':
      "Impossible d'accepter l'échange. L'équipe réserve de {username} dépasserait la limite de joueurs ({limit})",
    'failed.load.trades': "Échec du chargement des offres d'échange",
    'failed.load.requests': "Échec du chargement des demandes d'adhésion",

    // League Privacy Settings
    'league.privacy.settings': 'Paramètres de Confidentialité',
    'private.league': 'Ligue Privée',
    'public.league': 'Ligue Publique',
    'private.league.description':
      'Seuls les membres invités peuvent rejoindre cette ligue',
    'public.league.description': 'Tout le monde peut rejoindre cette ligue',

    'pending.requests': 'demandes en attente',

    // Join League Page
    'join.league.page': 'Rejoindre une Ligue',
    loading: 'Chargement...',
    'no.leagues.available':
      'Aucune ligue disponible à rejoindre pour le moment.',
    'created.on': 'Créée le {date}',
    'send.request': 'Envoyer la Demande',
    'request.sent': 'Demande envoyée pour rejoindre {name}',
    'already.member': 'Vous êtes déjà membre de {name}',
    'joined.success': 'Vous avez rejoint {name} avec succès !',
    'failed.join': "Échec de l'adhésion à la ligue",
    'failed.load.leagues': 'Échec du chargement des ligues disponibles',

    // Create League Page
    'create.league.title': 'Créer une Nouvelle Ligue',
    'league.name': 'Nom de la Ligue',
    'league.privacy': 'Confidentialité de la Ligue',
    'make.private': 'Rendre cette ligue privée',
    'private.description':
      'Les ligues privées ne sont visibles que par les membres invités',
    'creating.league': 'Création de la ligue...',
    'league.created': 'Ligue créée avec succès !',
    'failed.create.league':
      'Une erreur est survenue lors de la création de la ligue',

    // System Recommendations
    'system.recommendations': 'Recommandations Système',
    'submit.recommendations': 'Soumettre des idées pour améliorer le système',
    'recommendation.category': 'Catégorie',
    'category.general': 'Amélioration Générale',
    'category.trading': "Système d'Échange",
    'category.roster': "Gestion de l'Effectif",
    'category.scoring': 'Système de Pointage',
    'category.interface': 'Interface Utilisateur',
    'recommendation.description': 'Votre Recommandation',
    'recommendation.placeholder': 'Décrivez votre suggestion en détail...',
    'send.recommendation': 'Envoyer la Recommandation',
    sending: 'Envoi en cours...',
    'recommendation.sent': 'Merci ! Votre recommandation a été envoyée.',
    'recommendation.error': "Échec de l'envoi de la recommandation",
    'recommendation.guidelines': 'Directives pour de Bonnes Recommandations',
    'guideline.clear': 'Soyez clair et détaillé dans votre explication',
    'guideline.specific':
      'Concentrez-vous sur des fonctionnalités ou améliorations spécifiques',
    'guideline.constructive': 'Fournissez des commentaires constructifs',

    // Join request notifications
    'join.request.received': 'Nouvelle demande d\'adhésion reçue de {username}',
    'join.request.notification': 'Vous avez reçu une nouvelle demande d\'adhésion pour {leagueName}',

    // Advanced Search
    'advanced.search.title': 'Recherche Avancée de Joueurs',
    'advanced.search.filters': 'Filtres de Recherche',
    'advanced.search.min.salary': 'Salaire Min',
    'advanced.search.max.salary': 'Salaire Max',
    'advanced.search.min.points': 'Points Min',
    'advanced.search.max.points': 'Points Max',
    'advanced.search.min.goals': 'Buts Min',
    'advanced.search.max.goals': 'Buts Max',
    'advanced.search.min.assists': 'Passes Min',
    'advanced.search.max.assists': 'Passes Max',
    'advanced.search.min.age': 'Âge Min',
    'advanced.search.max.age': 'Âge Max',
    'advanced.search.min.years': 'Années Min',
    'advanced.search.max.years': 'Années Max',
    'advanced.search.status': 'Statut',
    'advanced.search.ownership': 'Appartenance',
    'advanced.search.all.players': 'Tous les joueurs',
    'advanced.search.free.agents.only': 'Agents libres uniquement',
    'advanced.search.owned.only': 'Joueurs possédés uniquement',
    'advanced.search.results': 'Résultats',
    'advanced.search.no.results': 'Aucun joueur trouvé avec ces critères.',
    'advanced.search.loading': 'Recherche en cours...',
    'advanced.search.sort.by': 'Trier par',
    'advanced.search.apply.filters': 'Appliquer les filtres',
    'advanced.search.reset.filters': 'Réinitialiser',

    // Trade Page - Grilles Joueurs
    'trade.players.table.column.photo': 'Photo',
    'trade.players.table.column.name': 'Nom',
    'trade.players.table.column.position': 'Pos',
    'trade.players.table.column.status': 'Statut',
    'trade.players.table.column.goals': 'Buts',
    'trade.players.table.column.assists': 'Assists',
    'trade.players.table.column.points': 'Points',
    'trade.players.table.column.salary': 'Salaire',
    'trade.players.table.column.actions': 'Actions',

    // Trade Page - Grilles Gardiens
    'trade.goalies.table.column.photo': 'Photo',
    'trade.goalies.table.column.name': 'Nom',
    'trade.goalies.table.column.position': 'Pos',
    'trade.goalies.table.column.status': 'Statut',
    'trade.goalies.table.column.wins': 'Victoires',
    'trade.goalies.table.column.savepct': 'Arr%',
    'trade.goalies.table.column.shutouts': 'Blanchissages',
    'trade.goalies.table.column.salary': 'Salaire',
    'trade.goalies.table.column.actions': 'Actions',

    // Trade Page - Grilles Choix de draft
    'trade.draftpicks.table.column.description': 'Description',
    'trade.draftpicks.table.column.original': 'Propriétaire original',
    'trade.draftpicks.table.column.actions': 'Actions',

    // Tooltips
    'salary.retention.tooltip': 'Salaire original: {original} | Rétention reçue: -{pct}% | Salaire effectif: {effective}',
  },
};

function translate(
  key: string,
  language: 'en' | 'fr',
  params?: { [key: string]: string }
): string {
  let translation = translations[language][key] || key;

  if (params) {
    Object.keys(params).forEach((param) => {
      translation = translation.replace(`{${param}}`, params[param]);
    });
  }

  return translation;
}

export { translations, translate };